// Components
import Entity from '../../../../../../../common-utils/components/renders/entity/Entity';
import DropdownUserActionsRow from '../../dropdown/DropdownUserActionsRow';
import DetailsButton from '@/common-utils/components/renders/detailsButton/DetailsButton';
import { Badge } from '@/common-utils/components/ui/badge';
// Common
import USER_STATUS from '../../../enums/UserStatus';
import userFields from '../../../fields/userFields';
import RenderDateWithFromTime from '@/common-utils/components/renders/date/RenderDateWithFromTime';
import RouteUrls from '@/app/root/enums/RouteUrls';
import generateColumnDefByField from '@/common-utils/functions/generateColumnDefByField';
import Permissions from '@/app/permissions/Permissions';

const isOrganizationUser = true;
export const columnsUserId = 'users';
export const columnsUser = (headerPackage) => {
    return ([
        generateColumnDefByField({
            field: userFields.DETAILS,
            headerPackage: headerPackage,
            customCellFn: ({ row }) => (
                <DetailsButton
                    pathParams={{ userId: row.original.uuid }}
                    baseUrl={RouteUrls.USER_DETAILS.url}
                    requiredPermissions={[Permissions.USER_READ.name]}
                />
            )
        }),
        generateColumnDefByField({
            field: userFields.UUID,
            headerPackage: headerPackage,
            customCellFn: ({ row }) => (
                row && isOrganizationUser &&
                <DropdownUserActionsRow user={row.original} setLaunchRefetch={headerPackage.setLaunchRefetch} />
                // : row && isAccountsUser ?
                //     <DropdownActionsAccountsUserRow user={row.original} />
            )
        }),
        generateColumnDefByField({
            field: userFields.STATUS,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                const userStatus = USER_STATUS[cell.getValue()];
                return (
                    userStatus &&
                    <Badge entity={userStatus.entity} namespace={userStatus.namespace} variant={userStatus.variant} />
                );
            }
        }),
        generateColumnDefByField({
            field: userFields.EMAIL,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: userFields.PROFILE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell && cell.getValue(userFields.PROFILE.key) ?
                    <Entity nowrap entity={`${userFields.PROFILE.prefix}${cell.getValue(userFields.PROFILE.key)}`} namespace={userFields.PROFILE.namespace} />
                    : '-'
            )
        }),
        generateColumnDefByField({
            field: userFields.ADVANCED_AUTH,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <Entity nowrap
                    entity={`${userFields.ADVANCED_AUTH.prefix}${cell.getValue(userFields.ADVANCED_AUTH.key)}`}
                    namespace={userFields.ADVANCED_AUTH.namespace}
                />
            )
        }),
        generateColumnDefByField({
            field: userFields.LAST_LOGIN_AT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(userFields.LAST_LOGIN_AT.key)} />
            )
        }),
        generateColumnDefByField({
            field: userFields.CREATED_AT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(userFields.CREATED_AT.key)} />
            )
        }),
        generateColumnDefByField({
            field: userFields.UPDATED_AT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(userFields.UPDATED_AT.key)} />
            )
        })
    ]);
};